import {
  ADDLIFEDETAILS,
  ADDLIFENUMBER,
  ALLLIFEDETAILS,
  LIFENUMFLAG,
  LIFE_INS_PRODUCT,
  CUST_DETAIL_LIFE,
  LIFE_QQ_POST,
  LIFE_QUOTE,
  ERROR_QUOTES_LIFE,
  LIFE_PREV_INS_LIST,
  LIFE_OFF_REQUEST,
} from "../actiontypes/NumLifeActiontypes";
import {
  SELECTED_LIFE_PLAN,
  PAY_TILL_AGE,
  PAY_TILL_UPDATE,
} from "../actiontypes/NumBikeActiontypes";
import axiosInstance from "../axios/AxiosInstance";
import axiosInPosp from "../axios/AxiosInPosp";

export const numlifeflagfalse = () => {
  return {
    type: LIFENUMFLAG,
  };
};
export const alllifedetails = () => {
  return {
    type: ALLLIFEDETAILS,
  };
};
export const addlifenum = (data) => {
  console.log(data);
  return {
    type: ADDLIFENUMBER,
    payload: data,
  };
};
export const addlifedetails = (data) => {
  return {
    type: ADDLIFEDETAILS,
    payload: data,
  };
};
export const CustLife_detail = (data) => {
  return {
    type: CUST_DETAIL_LIFE,
    payload: data,
  };
};

export const PostQuoteLife = (data) => {
  return {
    type: LIFE_QQ_POST,
    payload: data,
  };
};
export const QuickQuoteLife = (data) => {
  return {
    type: LIFE_QUOTE,
    payload: data,
  };
};

export function ErrQuotesLife(data) {
  return {
    type: ERROR_QUOTES_LIFE,
    payload: data,
  };
}
export function SelectedPayMethod(data) {
  return {
    type: SELECTED_LIFE_PLAN,
    payload: data,
  };
}
export function SelectedPayTill(data) {
  return {
    type: PAY_TILL_AGE,
    payload: data,
  };
}
export function PayTillUpdate(data) {
  return {
    type: PAY_TILL_UPDATE,
    payload: data,
  };
}
export function prev_life_insurance_list(data) {
  return {
    type: LIFE_PREV_INS_LIST,
    payload: data,
  };
}
export function OfflineLifeData(data) {
  return {
    type: LIFE_OFF_REQUEST,
    payload: data,
  };
}
export const insuranceproduct = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get("insurance_product/2")
        .then(function (response) {
          console.log(response);
          dispatch(insurance_product_action(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  };
};
export const Previousinsurer = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInPosp
        .get("previous_insurer_list")
        .then(function (response) {
          // console.log(response);
          dispatch(prev_life_insurance_list(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error.message);
          reject(error);
        });
    });
  };
};
export function insurance_product_action(devices) {
  return {
    type: LIFE_INS_PRODUCT,
    payload: devices,
  };
}
